


import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { AgentKb } from "App";
import { EventBus } from "App/IOC";
import { AgentKbExchange, AgentKbThread } from "App/Models/AgentKb";

/* UN FIL ENTIER — toutes les questions d'une conversation avec l'agent, dans
   l'ordre ( `/console/conversations/{id}` ). Pose dans le volet de la vue
   generale ( « Voir toute la conversation » ) et a droite de l'ecran des
   conversations.

   Un echange lu seul trompe : « et pour la location ? » ne veut rien dire sans
   la question d'avant. */

/* Le ticket ouvert par l'agent, dans HelpScout. L'identifiant rendu par le
   service est celui de la CONVERSATION HelpScout, pas son numero de ticket. */
export function HelpScoutUrl( id: number ): string {
    return "https://secure.helpscout.net/conversation/" + String( id );
}

@Component
export default class AgentKbThreadView extends Vue {
    @Prop( { type: String, required: true } )
    public readonly ConversationId!: string;

    /* L'echange d'ou l'on vient : il est marque dans le fil. */
    @Prop( { type: Number, default: 0 } )
    public readonly Highlight!: number;

    private thread: AgentKbThread | null = null;
    private loading: boolean = false;

    private alive: boolean = true;

    private created(): void {
        this.load();
    }

    private beforeDestroy(): void {
        this.alive = false;
    }

    @Watch( "ConversationId" )
    private onConversation(): void {
        this.load();
    }

    private async load(): Promise<void> {
        this.loading = true;
        this.thread = null;

        const [ thread, error ] = await AgentKb.Conversation( this.ConversationId );

        if( !this.alive )
            return;

        this.loading = false;

        if( error !== undefined ) {
            EventBus.Publish( "Error", error );
            return;
        }

        this.thread = thread !== undefined ? thread : null;
    }

    private helpScout( exchange: AgentKbExchange ): string {
        return exchange.helpscoutConversationId !== null
            ? HelpScoutUrl( exchange.helpscoutConversationId )
            : "";
    }

    private articleOf( exchange: AgentKbExchange ): string {
        return exchange.articleTitle || exchange.articleKbId || "—";
    }

    private formatDate( iso: string ): string {
        const date = new Date( iso );

        if( isNaN( date.getTime() ) )
            return "—";

        return date.toLocaleDateString( "fr-FR", {
            day: "numeric", month: "short", hour: "2-digit", minute: "2-digit"
        } );
    }
}
